import { ApolloCache, FetchResult } from "@apollo/client";
import {
	Announcement,
	AnnouncementCreateInput,
	AnnouncementCreateMutation,
	AnnouncementDeleteMutation,
	AnnouncementUpdateInput,
	AnnouncementUpdateMutation,
	clearTimelineQueryCache,
} from "../../../Utilities";
import * as AnnouncementFormValues from "./form-values";

export function customUpdateCacheForCreate(
	_input: AnnouncementCreateInput,
	cache: ApolloCache<any>,
	_result: Omit<FetchResult<AnnouncementCreateMutation, Record<string, any>, Record<string, any>>, "context">,
) {
	clearTimelineQueryCache(cache);
}

export function customUpdateCacheForUpdate<
	K extends keyof AnnouncementFormValues.Detail = keyof AnnouncementFormValues.Detail,
>(
	_input: AnnouncementUpdateInput,
	_initialFormValues: AnnouncementFormValues.DetailSubset<K>,
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<AnnouncementUpdateMutation, Record<string, any>, Record<string, any>>, "context">,
) {}

export function customUpdateCacheForDelete(
	_id: Announcement["id"],
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<AnnouncementDeleteMutation, Record<string, any>, Record<string, any>>, "context">,
) {}
